<template>
    <div class="accommodations-banner">
         <navComponent :activeName="activeName"></navComponent>
        <div class="accommodations-banner-center banner-fade-in">
            <div class="accommodations-banner-content" ref="animate">
                <div class="title">The Traffic</div>
                <div class="desc">On each trip our team will book the best accommodation within the respective itinerary.</div>
            </div>
        </div>
    </div>
</template>
<script>
import navComponent from '/components/pc/headerComponent/navComponent.vue'
export default{
    components:{
        navComponent
    },
    data(){
        return {
            activeName:'third',
        }
    },
    mounted() {
        this.$nextTick(() => {
            const contentElement = this.$refs.animate;
            contentElement.classList.add('animate');
        })
    }
}
</script>
<style scoped lang="scss">
@import '/style/pc/common/animate.scss';
@import '/style/pc/common/fadeIn.scss';
@import '/style/phone/header/trafficBanner.scss';
.accommodations-banner{
    width: 100%;
    .accommodations-banner-center{
        height: 39.375rem;
        background: url('/static/img/banner/traffic.png') no-repeat center center;
        background-size: cover;
        // min-width: 75rem;
        // max-width: 128rem;
        width: 100%;
        margin: 5.5rem auto 0;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .accommodations-banner-content{
            opacity: 0;
            transform: translateY(100%);
        }
        .title{
            margin-bottom: 1.875rem;
            color: #FFF;
            font-size: 4rem;
            font-weight: 700;
            line-height: 1.2;
            text-transform: capitalize;
            font-family: Butler;
        }
        .desc{
            color: #FFF;
            text-align: center;
            font-size: 1.25rem;
            font-weight: 300;
            font-family: Inter;
            width: 46.5rem;
        }
    }
    
}
</style>